import React, { Component } from 'react';
import { StyleSheet, css } from 'aphrodite';
import { Tab, Tabs } from '@material-ui/core';
import { AppTheme } from '../../../styles/AppTheme';
import { Helper } from '../../helpers/Helper';
import TableCard from './TableCard';
export class TabTableCard extends Component {
  constructor(props) {
    super(props);
    this.state = {
      cardMinHeight: null
    }
  }

  componentDidMount() {
    requestAnimationFrame(() => this.updateCardMinHeight())
  }

  componentDidUpdate() {
    if (this.props.lockTabMinHeight && !this.cardFillHeight) {
      this.updateCardMinHeight()
    }
  }

  getVisibleFillHeight() {
    const minFill = Helper.isMobileView() ? 200 : 400
    const container = typeof document !== 'undefined' ? document.getElementById('modalContainer') : null
    const bottom = container ? container.getBoundingClientRect().bottom : window.innerHeight
    const el = this.cardRef
    const top = el && el.getBoundingClientRect ? el.getBoundingClientRect().top : 0
    return Math.max(minFill, Math.round(bottom - top) + 24)
  }

  updateCardMinHeight() {
    if (!this.props.lockTabMinHeight || !this.cardRef || this.cardFillHeight) { return }
    const height = this.getVisibleFillHeight()
    if (this._pendingFillHeight !== height) {
      this._pendingFillHeight = height
      requestAnimationFrame(() => this.updateCardMinHeight())
      return
    }
    this.cardFillHeight = height
    if (this.state.cardMinHeight !== height) {
      this.setState({ cardMinHeight: height })
    }
  }

  handleTabChange = (event, tab, {tableType}) => {
    if(this.props.selectedTabData && this.props.handleTabChange) {
      this.props.handleTabChange(tab, tableType)
    }
  };

  render() {
    const {tableType, tabsData, tableTitle = '', tableData, selectedTabData, disableTooltip = false, showMoreInTable = false, tableRowActions, cellWidths = {}, standardTabView = false, maxRows = 10, showTabSeparator = false, hideRowSeparators = false, hideTableHeader = false, hideTabs = false, inProcess = false, reverseRows = false, renderTabActions, lockTabMinHeight = false, showMoreRows, nextPage, nextPageState, onNext} = this.props
    if(!tableType || !tabsData || !tableData || !selectedTabData) {
      return null
    }
    const selectedTab = tabsData[tableType] && tabsData[tableType][selectedTabData[tableType]]
    const tabActions = renderTabActions && renderTabActions(selectedTab, tableType)

    return (
      <div
        ref={el => { this.cardRef = el }}
        className={css(Styles.outerContainer)}
        style={lockTabMinHeight && this.state.cardMinHeight ? { minHeight: this.state.cardMinHeight } : undefined}
      >
        {!hideTabs && tabsData[tableType].length > 1 && (
          <div className={css(Styles.tabsRow)}>
            <Tabs value={selectedTabData[tableType]}
              onChange={(event, tab) => this.handleTabChange(event, tab, {tableType})}
              variant= {standardTabView ? 'standard' : 'fullWidth'}
              TabIndicatorProps={{ style: { display: 'none' }}}
              className={css(Styles.tabs)} >
              {
                tabsData[tableType].map((table, index)=> {
                  return(<Tab key={table.reportType} disableRipple label={
                    <div className={css(Styles.tabLabelContainer)}>
                      <span className={css(Styles.tabLabel1)}>{table.title}</span>
                    </div>
                  } className={css(Styles.tab, (showTabSeparator && Styles.tabWithSeparator), (selectedTabData[tableType] === index && Styles.selectedTab))}/>)
                })
              }
            </Tabs>
            {tabActions && <div className={css(Styles.tabActions)}>{tabActions}</div>}
          </div>
        )}
        <div className={lockTabMinHeight ? css(Styles.tableBodyWrap) : undefined}>
          <TableCard
            item={{data: tableData, title: !hideTabs && tabsData[tableType].length === 1 ? tableTitle : '' , maxRows: maxRows}}
            isTabTable={true}
            reverseRows={reverseRows}
            hideRowSeparators={hideRowSeparators}
            hideTableHeader={hideTableHeader}
            disableTooltip={disableTooltip}
            showMoreInTable={showMoreInTable}
            showMoreRows={showMoreRows}
            nextPage={nextPage}
            nextPageState={nextPageState}
            onNext={onNext}
            tableRowActions={tableRowActions}
            cellWidths={cellWidths}
            selectedTab={selectedTabData[tableType]}
            lockTabMinHeight={lockTabMinHeight}
            inProcess={inProcess}/>
        </div>
      </div>
    );
  }
}

const Styles = StyleSheet.create({
  outerContainer: {
    display: 'flex',
    flexDirection: 'column',
    gap: 2,
    border: '1px solid ' + AppTheme.borderColor,
    borderRadius: AppTheme.borderRadius,
  },
  tableBodyWrap: {
    flex: 1,
    minHeight: 0,
    display: 'flex',
    flexDirection: 'column',
  },
  tabsRow: {
    display: 'flex',
    alignItems: 'stretch',
    height: '80px',
    backgroundColor: AppTheme.secondaryColor,
    borderTopLeftRadius: AppTheme.borderRadius,
    borderTopRightRadius: AppTheme.borderRadius,
  },
  tabs: {
    height: '80px',
    flex: 1,
    backgroundColor: AppTheme.secondaryColor,
    borderTopLeftRadius: AppTheme.borderRadius,
    borderTopRightRadius: AppTheme.borderRadius,
  },
  tabActions: {
    display: 'flex',
    alignItems: 'center',
    flexShrink: 0,
    paddingRight: 16,
    borderBottom: '1px solid ' + AppTheme.borderColor,
  },
  tab: {
    height: '80px',
    backgroundColor: AppTheme.secondaryColor,
    borderTopLeftRadius: AppTheme.borderRadius,
    borderTopRightRadius: AppTheme.borderRadius,
    borderBottom: '1px solid ' + AppTheme.borderColor,
  },
  tabWithSeparator: {
    borderRight: '1px solid ' + AppTheme.borderColor,
  },
  selectedTab: {
    backgroundColor: 'white',
    color: AppTheme.buttonBg,
    borderBottom: 0,
  },
  tabLabelContainer: {
    display: 'flex',
    height: '100%',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
  },
  tabLabel1: {
    textTransform: 'capitalize',
    fontSize: 18,
    fontWeight: 500,
    '@media(max-width: 767px)': {
      fontSize: 14
    }
  },
})
